<div class="vault-container">

    <lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>

    <div class="vault-header">
        <div class="vault-header-row">
            <h1>Documents</h1>
            <div *ngIf="isInternalUser">
                <button mat-button color="primary" (click)="onAddVaultDocument()">
                    <mat-icon>add</mat-icon> Add Document
                </button>
            </div>
        </div>
    </div>

    <div class="vault-document-list">
        <div class="vault-document-item" *ngFor="let doc of vaultDocuments$ | async">
            <div class="vault-document-content">
                <div class="vault-document-icon" (click)="openVaultDocument(doc)">
                    <i class="fa-solid fa-file-lines" style="color: #6D6E71;"></i>
                </div>
                <div class="vault-document-details">
                    <div class="vault-document-name" (click)="openVaultDocument(doc)">
                        {{ doc.title }}
                        <i
                            class="fa-regular fa-lock"
                            *ngIf="doc.isInternal"
                            matTooltip="Internal document, not visible to clients"
                        ></i>
                    </div>
                    <div class="vault-document-blobname">
                        {{ doc.blobName }}
                    </div>
                </div>
                <div class="vault-document-date">
                    {{ doc.updatedTimestamp | date: 'MM/dd/yy' }}
                </div>
                <div class="vault-document-menu">
                    <ng-container *ngIf="isInternalUser">
                        <button
                            mat-icon-button
                            [matMenuTriggerFor]="taskMenu"
                            [matMenuTriggerData]="{ doc: doc }"
                            class="ellipsis-button"
                        >
                            <mat-icon>more_vert</mat-icon>
                        </button>
                    </ng-container>
                    <ng-container *ngIf="!isInternalUser">
                        <button mat-icon-button (click)="openVaultDocument(doc)" title="View Document">
                            <mat-icon>visibility</mat-icon>
                        </button>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <mat-menu #taskMenu="matMenu">
        <ng-template matMenuContent let-doc="doc">
            <button mat-menu-item (click)="openVaultDocument(doc)">
                <mat-icon>visibility</mat-icon>
                <span>Open</span>
            </button>
            <button mat-menu-item (click)="deleteDocument(doc.id)">
                <mat-icon>delete</mat-icon>
                <span>Delete</span>
            </button>
        </ng-template>
    </mat-menu>

    <lgv-file-upload-box
        [isInternalUser]="isInternalUser"
        [uploadBoxCSS]="uploadBoxCSS"
        [showInternalUserCheck]="true"
        [customText]="'Drag and drop, choose file, or upload photo'"
        (dragOver)="onDragOver($event)"
        (dropSuccess)="onDropSuccess($event)"
        (dragLeave)="onDragLeave($event)"
        (clickEvent)="onClickEvent($event)"
    ></lgv-file-upload-box>
</div>
